import { cn } from '../../lib/utils'

export default function Card({ children, className, hover = false, padding = false }) {
  return (
    <div
      className={cn(
        'bg-white rounded-2xl border border-gray-100 shadow-card',
        hover && 'transition-shadow duration-200 hover:shadow-card-hover',
        padding && 'p-6',
        className
      )}
    >
      {children}
    </div>
  )
}